const { client } = require('../../MbaasClient')

export const funcGetOneDenomPricingsSetup = async (resource, params) => {
  const { data } = await client.getTable('products').lookup(params.id)
  return { data }
}
